/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesProfileGetTwitchGameData
 */
export interface FxIdWebFeaturesProfileGetTwitchGameData {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesProfileGetTwitchGameData
     */
    UserId: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesProfileGetTwitchGameData
     */
    AccessToken: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesProfileGetTwitchGameData
     */
    RefreshToken: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesProfileGetTwitchGameData interface.
 */
export function instanceOfFxIdWebFeaturesProfileGetTwitchGameData(value: object): value is FxIdWebFeaturesProfileGetTwitchGameData {
    if (!('UserId' in value) || value['UserId'] === undefined) return false;
    if (!('AccessToken' in value) || value['AccessToken'] === undefined) return false;
    if (!('RefreshToken' in value) || value['RefreshToken'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesProfileGetTwitchGameDataFromJSON(json: any): FxIdWebFeaturesProfileGetTwitchGameData {
    return FxIdWebFeaturesProfileGetTwitchGameDataFromJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileGetTwitchGameDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesProfileGetTwitchGameData {
    if (json == null) {
        return json;
    }
    return {
        
        'UserId': json['UserId'],
        'AccessToken': json['AccessToken'],
        'RefreshToken': json['RefreshToken'],
    };
}

export function FxIdWebFeaturesProfileGetTwitchGameDataToJSON(json: any): FxIdWebFeaturesProfileGetTwitchGameData {
    return FxIdWebFeaturesProfileGetTwitchGameDataToJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileGetTwitchGameDataToJSONTyped(value?: FxIdWebFeaturesProfileGetTwitchGameData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'UserId': value['UserId'],
        'AccessToken': value['AccessToken'],
        'RefreshToken': value['RefreshToken'],
    };
}

